export default __webpack_public_path__ + "static/media/lankanfillingstation.dd5433ff.jpeg";